<div class="modal-header">
  <h4 class="modal-title header-5">
    {{ title }}
  </h4>
  <button
    type="button"
    class="accello-icon-btn"
    (mousedown)="isActive = true"
    (mouseup)="isActive = false"
    (mouseleave)="isActive = false"
    (click)="activeModal.dismiss('Cross click')"
  >
    <img
      alt="Close"
      [src]="
        isActive
          ? 'assets/images/virtusa-icons/close-dark.svg'
          : 'assets/images/virtusa-icons/close.svg'
      "
    />
  </button>
</div>

<div class="modal-body pt-0 mt-3 w-100 mx-0">
  <div class="d-flex flex-column gap-3">
    <label class="form-label mb-0 me-3 label-width"> User Story </label>

    <select id="select-story" class="form-select" (change)="onSelectChange()" [(ngModel)]="selectedStory">
        <option value="" disabled>
          Select User Story
        </option>
      @for (story of userStories; track story) {
        <option
          [value]="story.value"
          [selected]="story.value === selectedStory"
        >
          {{ story.label }}
        </option>
      }
    </select>

    <label class="form-label mb-0 me-3 label-width"> Priority </label>

    <div class="d-flex gap-2 flex-nowrap">
      <span
        *ngFor="let item of priorities"
        class="priority-div"
        [ngClass]="[
          getPriorityClass(item),
          selectedPriority === item ? 'selected' : '',
        ]"
        (click)="selectPriority(item)"
        (keydown.enter)="selectPriority(item)"
      >
        {{ item }}
      </span>
    </div>
  </div>
</div>

<div class="modal-footer">
  <div class="d-flex justify-content-between w-100">
    <label class="reset" (click)="resetAll()" (keydown.enter)="resetAll()"
      >Reset all</label
    >
    <button class="btn-accello-primary-light" (click)="apply()">Apply</button>
  </div>
</div>
